import { forwardRef } from 'react';

export interface InputActionProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const InputAction = forwardRef<HTMLDivElement, InputActionProps>(({
  children,
  className = '',
  ...props
}, ref) => {
  const actionClasses = [
    'w-16',
    'self-stretch',
    'p-2',
    'rounded-[99px]',
    'flex',
    'justify-center',
    'items-center',
    className
  ].filter(Boolean).join(' ');

  return (
    <div ref={ref} className={actionClasses} {...props}>
      {children}
    </div>
  );
});

InputAction.displayName = 'InputAction';

export default InputAction;